import { cnpj } from "cpf-cnpj-validator";
import { FieldValue, deleteField } from "firebase/firestore";
import { pt } from "yup-locale-pt";
import { yup } from "./schema";

yup.setLocale(pt);

/**
 * Add deleteField from empty string
 */
yup.addMethod(yup.mixed<string | ReturnType<typeof deleteField>>, "firebaseDeleteEmptyField", function () {
  return this.transform(function (value: string) {
    if (this.isType(value) && (!value || value === "")) {
      return deleteField();
    }
    return value as string | FieldValue;
  });
});

yup.addMethod(yup.string, "cnpj", function () {
  return this.test({
    name: "cnpj",
    message: "${path} inválido",
    test: function (value) {
      if (typeof value !== "string" || value.length === 0) {
        return true;
      }

      return cnpj.isValid(value);
    }
  });
});

yup.addMethod(yup.string, "phone", function () {
  return this.test({
    name: "phone",
    message: "${path} inválido. Use o formato (##) ####-#### ou (##) #####-####",
    test: function (value) {
      if (typeof value !== "string" || value.length === 0) {
        return true;
      }

      // Remove todos os caracteres não numéricos
      const numbers = value.replaceAll(/\D/g, "");

      // Aceita telefone fixo (10 dígitos) ou celular (11 dígitos)
      // Formato: (DD) NNNN-NNNN ou (DD) NNNNN-NNNN
      return numbers.length === 10 || numbers.length === 11;
    }
  });
});

export default { ...yup };
